import React, {Component} from 'react'
import CalendarComponent from '../../components/Calendar/Calendar'

class OADashboard extends Component {
    render() {
        return (
            <>
               <CalendarComponent />

            </>
        )
    }
}
export default OADashboard